import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "sourceSelect",
    ]
    static values = { targetSelect: String }

    targetSelectOptGroups = [];
    targetSelect;
    targetSelectWrapper;
    targetSelectSelectedIndex;

    connect() {
        this.targetSelect = document.getElementById(this.targetSelectValue);
        this.targetSelectWrapper = this.targetSelect.closest("." + this.targetSelectValue);
        this.targetSelectSelectedIndex = this.targetSelect.selectedIndex;
        this.targetSelectOptGroups = Array.from(this.targetSelect.querySelectorAll("optgroup"));
        // Avoid UI flickering
        Turbolinks.clearCache();
        // Delay to let select instances to correctly initialize
        setTimeout(() => {
            this.filterTargetSelect();
        }, 10)
    }

    filterTargetSelect() {
        let sourceSelected = this.sourceSelectTarget.options[this.sourceSelectTarget.selectedIndex]?.text || "";
        if (sourceSelected.length) {
            this.targetSelectWrapper.style.display = "block";
            const targetOptGroups = this.targetSelectOptGroups.filter(item =>
                item.label === sourceSelected
            );
            if (targetOptGroups.length) {
                if (targetOptGroups[0].firstChild && targetOptGroups[0].firstChild.value !== "") {
                    const option = document.createElement("option");
                    targetOptGroups[0].prepend(option);
                }
                this.targetSelect.innerHTML = targetOptGroups[0].innerHTML;
            } else {
                this.targetSelect.innerHTML = "";
            }
            this.targetSelect.dispatchEvent(new Event('change'));
        } else {
            this.targetSelectWrapper.style.display = "none";
            this.targetSelect.innerHTML = "";
        }
    }

}